import FetchProxy from "./FetchProxy";

export default class RememberChangePassword {
    formSelector =".js-login-form";
    buttonSelector = ".js-remember-password-btn";
    successDivSelector = ".alert-success";

    /**
     * Proxy para hacer llamdas a fetch
     * @type {null}
     */
    fetchProxy=null;

    debug=true;


    constructor() {
        this.fetchProxy=new FetchProxy();
    }

    get$Form() {
        if (this.$_form==null) {
            this.$_form=$(this.formSelector);
            this.log("form=" + this.formSelector);
        }
        return this.$_form;
    }

    onRememberChangePasswordSuccess() {
        this.log("logging ok");
        $(this.successDivSelector).html('Si el email está registrado se enviará un correo con las instrucciones para obtener una nueva contraseña').show();
    }

    onChangedPasswordSuccess() {
        $(this.successDivSelector).html('Se ha cambiado la clave correctamente. Puede usar la nueva clave para entrar en la aplicación').show();
    }

    // Loguea en consola el mensaje. Sólo útil en depuración
    log(message) {
        if (this.debug) {
            console.log(message);
        }
    }

    t(s) {
        return s
    }

    isMail(email) {
        if (email == "" || (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){

            return (true)
        } else {


            return (false);
        }
    }

    async fetchUrlPostUrlEncoded(url, postdataobj, params) {
        let result = await this.fetchProxy.fetchUrlPostUrlEncoded(url, postdataobj, params);
        return result;
    }

    /**
     * in is [ {name:1,value:4} ] and out is {"name":1}
     * @param nameValuePair
     * @returns {{}|*}
     */
    getAsPureArray(nameValuePair) {
        let result={};
        nameValuePair.forEach(function(nameValue, index) {
            result[nameValue.name]=nameValue.value;
        });
        return result;
    }

    async validateAndRememberPassword() {
        let me = this;
        let $form = this.get$Form();
        let request = $form.serializeArray();
        let namesFormMultiple = {};

        let restUrl = me.restUrl;
        if (restUrl == null) {
            restUrl = $(this.formSelector).attr("action");
        }
        // Para los elementos múltiples crea un array
        $(me.buttonSelector).prop("disabled", true);
        $form.find(".js-login-error").html("").hide();
        $form.find(this.successDivSelector).html("").hide();


        try {
            //restUrl='https://api.spotify.com/v1/artists/0OdUWJ0sBjDrqHygGUXeCFcdsds';
            let requestPureArray = this.getAsPureArray(request);
            let response = await this.fetchUrlPostUrlEncoded(restUrl, requestPureArray);
            let data = await response.json();
            if (data.errorCode==0) {
                me.onChangedPasswordSuccess();

            } else {
                // {"errorCode":1,"errorMessage":"La clave debe ser al menos de 8 caracteres y debe contener mayusculas y minusculas, alg\u00fan digito y alg\u00fan caracter especial."}{"errorCode":1,"errorMessages":["Usuario no encontrado"]}

                let errorMessages = { "0": {"errorMessage": "El formato del email no es válido" } };
                me.onLoginError(data.errorMessages);
                $(me.buttonSelector).prop("disabled", false);
            }
        } catch (e) {
            $(me.buttonSelector).prop("disabled", false);
            me.onLoginError(e.errorMessages);
        }
    }


    /**
     * Se ha producido un error al hacer el login. Se muestra el mensaje de error
     * @param messages
     */
    onLoginError(messages) {
        let $form = this.get$Form();
        console.log(messages);
        let message=this.t("Error al enviar los datos");
        try {
            message = messages["errorMessage"];
        } catch(e) {

        }
        $form.find(".js-login-error").html(message).show();
    }

    /**
     * Inicializa los eventos del formulario para que cuando se pulse en "enviar" se activen los eventos necesarios
     */
    initEvents() {
        $(this.buttonSelector).click(()=> {
            this.validateAndRememberPassword();

            return false;
        })
    }
}